// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createStore } from "effector";
import { SurveyInfoResponseDTO } from "../../api/backend-openapi";
import { deleteSurvey, setSurveys, updateSurvey } from "./SurveysEvents";

export const SurveyStore = createStore<SurveyInfoResponseDTO[]>([])
  .on<SurveyInfoResponseDTO[]>(
    setSurveys,
    (state: SurveyInfoResponseDTO[], payload: SurveyInfoResponseDTO[]) =>
      payload
  )
  .on<string>(deleteSurvey, (state: SurveyInfoResponseDTO[], payload: string) =>
    state.filter(survey => survey.id !== payload)
  )
  .on<SurveyInfoResponseDTO>(
    updateSurvey,
    (state: SurveyInfoResponseDTO[], payload: SurveyInfoResponseDTO) => [
      ...state.filter(survey => survey.id !== payload.id),
      payload
    ]
  );
